<template>
  <div style="margin-left: 8px">
    <p>Opportunity（30%）：</p>
    <p>Meet one or more of the following four items.</p>
    <p>①&nbsp;The project fund is not in place yet</p>
    <p>②&nbsp;Detailed requirements are not clear</p>
    <p>③&nbsp;The project timeline is not clear</p>
    <p>④&nbsp;The decision makers are not clear</p><br>

    <p>Potential（50%）：</p>
    <p>①&nbsp;The customer's decision maker must be a Ruijie supporter or mentors.</p>
    <p>②&nbsp;The decision-making procedures and criteria are beneficial to Ruijie.</p>
    <p>③&nbsp;Ruijie is comparable with other competitors or not at an advantage in this project.</p><br>

    <p>Advantage（70%）：</p>
    <p>Non-ELV(Extra Low Voltage) project：</p>
    <p>①&nbsp;The customer's decision maker must be a Ruijie supporter or mentors.</p>
    <p>②&nbsp;The decision-making procedures and criteria are beneficial to Ruijie.</p>
    <p>③&nbsp;Ruijie has advantages over the competitors in this project.</p>
    <p>ELV(Extra Low Voltage) project：</p>
    <p>The tender of OEM or single procurement source has been released and the ELV</p>
    <p>project contractor has won the tender.</p> <br>

    <p>Guarantee（90%）：</p>
    <p>Non-ELV project：Tender-winning project which has or has not signed the contract</p>
    <p>ELV project: Project which has signed contract with the ELV project contractor</p>
  </div>
</template>

<script>
export default {
  name: 'ProjectPhaseDesc'
};
</script>

<style scoped>

</style>
